import React, { useEffect, useState, useRef, useMemo } from "react";
import "./Header.scss";
import { useDispatch, useSelector } from "react-redux";
import c from "../../helpers/constants";
import { config } from "./../../config/config";
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { getBasket } from "../../selectors/Order";
import CONSTANTS from "../../helpers/constants";
import { getCustomer, isFetchingCustomer } from "../../selectors/Customer";
import { fetchCustomer } from "../../actions/Customer";
import LWModal from "../Modal/Modal";
import ChangePassword from "../ChangePassword";
import { clearBasketRequest } from "../../actions/Order";
import {
  getCustomerID,
  setCustomerBranch,
  setCustomerID,
  setCustomerPostcode,
  setCustomerStatus,
} from "../../helpers/functions";
import HeaderTicker from "../HeaderTicker";

const Header = () => {
  const basket = useSelector(getBasket);

  const dispatch = useDispatch();
  const [customerId, setCustomerId] = useState("");
  const [toggle, setToggle] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const hasFetchedCustomer = useRef(false);
  const lastHideDetailsRef = useRef<boolean>(true);
  const enablePricelists =
    config.hasOwnProperty("enablePricelists") && config.enablePricelists;
  const customer = useSelector(getCustomer);
  const isLoadingCustomer = useSelector(isFetchingCustomer);
  const customBrand = config.customBrand;
  
  // Use last known value if customer is null (during refetch), otherwise use current value
  const hideDetails = customer 
    ? (lastHideDetailsRef.current = customer.hidedetails === true)
    : lastHideDetailsRef.current;
  
  const showPrices = useMemo(() => customer ? customer.showprices === true : false, [customer]);
  const showBasket = useMemo(() => customer ? customer.showbasket === true : false, [customer]);
  const isCustomBrand = useMemo(() => customBrand && customer?.overridelogo, [customBrand, customer?.overridelogo]);
  const validCustomer = useMemo(() => customer ? config.enabledPayit.indexOf(customer.brn || '') > -1 : false, [customer]);

  useEffect(() => {
    setCustomerId(getCustomerID() as string);
  }, [dispatch]);

  useEffect(() => {
    if (!customer && !isLoadingCustomer && !hasFetchedCustomer.current) {
      hasFetchedCustomer.current = true;
      dispatch(fetchCustomer());
    }
  }, [customer, isLoadingCustomer]);

  const onLogout = () => {
    clearBasketRequest();
    setCustomerID("");
    setCustomerStatus("");
    setCustomerBranch("");
    setCustomerPostcode("");
    window.location.href = window.location.href;
  };

  return (
    <>
      <div className="navbar-outer">
        {config.enableSpecials &&
          config.headerBanner != null &&
          config.headerBanner.length > 0 && <HeaderTicker></HeaderTicker>}
        <Navbar
          bg="white"
          variant="light"
          expand="lg"
          className="nav-container"
        >
          <Navbar.Toggle aria-controls="navbarScroll">
            <label>
              <span></span>
              <span></span>
              <span></span>
            </label>
          </Navbar.Toggle>
          <Navbar.Brand as={Link} to={c.APP_ROUTES.DASHBOARD}>
            {!isLoadingCustomer &&
              (customBrand && isCustomBrand ? (
                <img
                  src={"/logos/" + customer?.overridelogo}
                  className="navbar-brand altbrand"
                  alt={config.companyName + " Logo"}
                />
              ) : (
                <img
                  src={config.likewiseLogo}
                  className="navbar-brand"
                  alt={config.companyName + " Logo"}
                />
              ))}
          </Navbar.Brand>
          <div className="desktop-hide">
            <NavLink to={c.APP_ROUTES.CART}>
              {basket?.length > 0 && (
                <div className="cart-indicator">{basket.length}</div>
              )}

              <img src={config.cartIcon} className="" alt="search-icon" />
            </NavLink>
          </div>
          <Navbar.Collapse id="navbarScroll">
            <Nav className="ms-auto navbarFlex">
              <NavLink
                to={c.APP_ROUTES.DASHBOARD}
                exact
                className="nav-link"
                activeClassName="active"
              >
                {config.menuLabels.home}
              </NavLink>
              <NavLink
                to={c.APP_ROUTES.PRODUCTS}
                exact
                className="nav-link"
                activeClassName="active"
              >
                {config.menuLabels.cats}
              </NavLink>
              {!hideDetails && (
              <NavLink
                to={c.APP_ROUTES.ORDERS}
                exact
                className="nav-link"
                activeClassName="active"
              >
                {config.menuLabels.orders}
              </NavLink>
              )}
              {config.showAbout && (
                <NavLink
                  to={c.APP_ROUTES.ABOUT}
                  exact
                  className="nav-link"
                  activeClassName="active"
                >
                  {config.menuLabels.about}
                </NavLink>
              )}
              <NavLink
                to={c.APP_ROUTES.CONTACT}
                exact
                className="nav-link"
                activeClassName="active"
              >
                {config.menuLabels.contact}
              </NavLink>
              {!hideDetails && (
              <NavLink
                to={c.APP_ROUTES.ACCOUNT}
                exact
                className="nav-link"
                activeClassName="active"
              >
                {config.menuLabels.account}
              </NavLink>
              )}
              <NavLink to={c.APP_ROUTES.SEARCH} className="mobile-hide">
                <img
                  src={config.searchIcon}
                  className="nav-link"
                  alt="Search"
                />
              </NavLink>
              {showBasket && (
                <NavLink to={c.APP_ROUTES.CART} className="nav-link">
                  {basket?.length > 0 && (
                    <div className="cart-indicator mobile-hide">
                      {basket.length}
                    </div>
                  )}
                  <img
                    src={config.cartIcon}
                    className="mobile-hide"
                    alt="search-icon"
                  />
                  <span className="desktop-hide">Basket ({basket.length})</span>
                </NavLink>
              )}
              <NavLink
                to={c.APP_ROUTES.SEARCH}
                className="desktop-hide nav-link"
              >
                <img
                  src={config.searchIcon}
                  className="nav-link"
                  alt="Search"
                />
              </NavLink>

              <NavDropdown
                title={
                  <>
                    <span className="account-no">Account No:</span>
                    <span className="text-red">{customerId}</span>
                  </>
                }
                id="basic-nav-dropdown"
              >
                {!hideDetails && (
                <NavDropdown.Item as={Link} to={CONSTANTS.APP_ROUTES.ACCOUNT}>
                  Account Information
                </NavDropdown.Item>
                )}
                {!hideDetails && showBasket && (
                  <NavDropdown.Item as={Link} to={CONSTANTS.APP_ROUTES.ORDERS}>
                    {config.menuLabels.orders}
                  </NavDropdown.Item>
                )}
                {!hideDetails && enablePricelists && !customer?.is_matting && showPrices && (
                  <NavDropdown.Item
                    as={Link}
                    to={CONSTANTS.APP_ROUTES.PRICELIST}
                  >
                    My Pricelist
                  </NavDropdown.Item>
                )}

                {!hideDetails && showBasket && (
                  <NavDropdown.Item
                    as={Link}
                    to={CONSTANTS.APP_ROUTES.ACCOUNT_SUMMARY}
                  >
                    {config.menuLabels.accountSummary}
                  </NavDropdown.Item>
                )}

                {!hideDetails && config.enablePayments == true &&
                  showBasket &&
                  validCustomer && (
                    <NavDropdown.Item
                      as={Link}
                      to={CONSTANTS.APP_ROUTES.MY_STATEMENTS}
                    >
                      Account Statement
                    </NavDropdown.Item>
                  )}
                {!hideDetails && (
                <NavDropdown.Item
                  as={Link}
                  to={CONSTANTS.APP_ROUTES.UPDATE_ACCOUNT_INFO}
                >
                  {config.menuLabels.updateAccount}
                </NavDropdown.Item>
                )}
                {!hideDetails && (
                <NavDropdown.Item onClick={() => setToggle(true)}>
                  {config.menuLabels.changePassword}
                </NavDropdown.Item>
                )}
                <NavDropdown.Item onClick={onLogout}>
                  {config.menuLabels.logout}
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
      <LWModal
        title="Change Password"
        onClose={() => {
          setToggle(false);
          setEmailSent(false);
        }}
        show={toggle}
      >
        <ChangePassword></ChangePassword>
      </LWModal>
    </>
  );
};

// Memoize Header to prevent unnecessary re-renders
// Header will only re-render when Redux state (basket, customer) or internal state changes
export default React.memo(Header);
